import { Form, Formik } from 'formik';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import SelectBox from '../../../shared/controls/form/selectBox';
import { DateBox, TextArea, TextBox } from '../../../shared/controls/form';
import {
  getActiveOwners,
  getGenericMasterFilteredListByKey,
  getQuoteList,
  getSalesOrder,
} from '../../../redux/selector';
import apiServices from '../../../services/service';
import PaginatedDropdown from '../../../shared/component/PaginatedDropdown';
import ChildInvoiceSalesOrder from './childInvoiceSalesOrder';
import useFetchIfNeeded from '../../../redux/useFetchIfNeeded';
import { fetchDataAndUpdateStore } from '../../../redux/actions';
import { salesOrderInputData } from '../../../shared/constants';

export const InvoiceForm = ({
  formData,
  selectedOptions,
  handleSubmit,
  handleChangeForm,
  handleChange,
  errormsg,
  handleDeleteRow,
  handleAddRow,
  quoteList,
  salesOrderList,
  handleAddPriceSheetToItems,
  handleSameAsBillingChange
}) => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const invoiceOwner = useSelector(getActiveOwners);
  // For Status
  const invoiceStatus = useSelector(getGenericMasterFilteredListByKey('InvoiceStatus'));

  const saleOrder = useSelector(getSalesOrder);
  const quote = useSelector(getQuoteList)
  // For Currency
  const currency = useSelector(getGenericMasterFilteredListByKey('Currency'));

  useFetchIfNeeded(getSalesOrder, fetchDataAndUpdateStore, {
    key: 'salesOrder',
    inputData: salesOrderInputData,
  });

  // Account dropdown
  const {
    options: accountListDropdown,
    isLoading: isAccountLoading,
    handleSearch: handleAccountSearch,
    handleScroll: handleAccountScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getAccountsDropdown, // Replace with actual API
    responseKey: 'accountList',
  });

  // Opportunity dropdown
  const {
    options: opportunityListDropdown,
    isLoading: isOpportunityLoading,
    handleSearch: handleOpportunitySearch,
    handleScroll: handleOpportunityScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getOpportunityDropdown,
    responseKey: 'opportunityList',
  });

  // Quote dropdown
  // const quoteListData = useSelector(getQuoteList);

  // For Contact
  const {
    options: contactListDropdown,
    isLoading: isContactLoading,
    handleSearch: handleContactSearch,
    handleScroll: handleContactScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getContactsDropdown,
    responseKey: 'contactList', // expected response key
  });

  return (
    <>
      <Formik initialValues={formData} onSubmit={(values) => handleSubmit(values)}>
        <Form>
          <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
            <div className="row gx-3">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/quoteAi/images/quoteInfo.svg" alt="" />
                      Invoice Information
                    </label>
                  </div>
                  <div className="quoteContent leadDetailInfo ">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label={'Invoice Owner'}
                              name={'invoiceOwnerId'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.invoiceOwner || '--'
                                  : formData?.invoiceOwner || 'Select Invoice Owner'
                              }
                              isRequired={false}
                              disabled={formData?.type === 'view'}
                              handleSelect={handleChange}
                              selectedOptions={selectedOptions?.invoiceOwnerId}
                              options={invoiceOwner}
                              optionKeys={['userId', 'display_name']}
                              errormsg={errormsg?.invoiceOwnerId}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <TextBox
                              isRequired={true}
                              label={'Subject'}
                              name={'subject'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter Subject'}
                              value={formData?.subject}
                              handleChange={handleChangeForm}
                              disabled={formData?.type === 'view'}
                              errormsg={errormsg?.subject}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <TextBox
                              isRequired={false}
                              label={'Purchase Order'}
                              name={'purchaseOrder'}
                              placeholder={
                                formData?.type === 'view' ? '--' : 'Enter Purchase Order'
                              }
                              handleChange={handleChangeForm}
                              value={formData?.purchaseOrder}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <div className="dateBox">
                              <label>Due Date</label>
                              {formData?.type === 'view' && !formData?.dueDate ? (
                                <div> --</div>
                              ) : (
                                <div className="dtBox custom-date-wrapper">
                                  <DateBox
                                    name={'dueDate'}
                                    className="custom-date-input"
                                    placeholder={
                                      formData?.type === 'view'
                                        ? '--'
                                        : 'Enter Due Date (MM/DD/YYYY)'
                                    }
                                    value={
                                      formData?.dueDate ? formData?.dueDate.substring(0, 10) : ''
                                    }
                                    disabled={formData?.type === 'view'}
                                    handleChange={handleChangeForm}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <div className="dateBox">
                              <label>Invoice Date</label>
                              {formData?.type === 'view' && !formData?.invoiceDate ? (
                                <div>--</div>
                              ) : (
                                <div className="dtBox custom-date-wrapper">
                                  <DateBox
                                    name={'invoiceDate'}
                                    className="custom-date-input"
                                    placeholder={
                                      formData?.type === 'view'
                                        ? '--'
                                        : 'Enter Invoice Date (MM/DD/YYYY)'
                                    }
                                    value={
                                      formData?.invoiceDate
                                        ? formData?.invoiceDate.substring(0, 10)
                                        : ''
                                    }
                                    disabled={formData?.type === 'view'}
                                    handleChange={handleChangeForm}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label="Status"
                              name={'status'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.status || '--'
                                  : formData?.status || 'Select Status'
                              }
                              isRequired={false}
                              disabled={formData?.type === 'view'}
                              selectedOptions={selectedOptions?.status}
                              handleSelect={handleChange}
                              options={invoiceStatus}
                              optionKeys={['id', 'displayName']}
                              errormsg={errormsg?.status}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container mb-2">
                            <label className="form-label">Sales Commission</label>

                            <div className="input-group">
                              <span className="input-group-text">$</span>
                              <input
                                type="number"
                                name="salesCommission"
                                className="form-control"
                                placeholder={
                                  formData?.type === 'view' ? '--' : 'Enter Sales Commission'
                                }
                                min="0"
                                step="0.01"
                                value={formData?.salesCommission ?? ''}
                                onChange={handleChangeForm}
                                disabled={formData?.type === 'view'}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container mb-2">
                            <SelectBox
                              label={'Currency'}
                              name={'currencyPrice'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.currencyPrice || '--'
                                  : formData?.currencyPrice || 'Select Currency'
                              }
                              isRequired={false}
                              disabled={formData?.type === 'view'}
                              options={currency}
                              optionKeys={['id', 'displayName']}
                              handleSelect={handleChange}
                              selectedOptions={selectedOptions?.currencyPrice}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container mb-2">
                            <label className="form-label">Excise Duty</label>

                            <div className="input-group">
                              <span className="input-group-text">$</span>
                              <input
                                type="number"
                                name="exciseDuty"
                                className="form-control"
                                placeholder={formData?.type === 'view' ? '--' : 'Enter Excise Duty'}
                                min="0"
                                step="0.01"
                                value={formData?.exciseDuty ?? ''}
                                onChange={handleChangeForm}
                                disabled={formData?.type === 'view'}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/quoteAi/images/quoteInfo.svg" alt="" />
                      Association With
                    </label>
                  </div>
                  <div className="quoteContent leadDetailInfo ">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label="Account Name"
                              name={'accountName'}
                              handleSelect={handleChange}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.accountName || '--'
                                  : formData?.accountName || 'Select Account Name'
                              }
                              isRequired={true}
                              disabled={formData?.type === 'view'}
                              selectedOptions={selectedOptions?.accountName}
                              options={accountListDropdown}
                              isLoading={isAccountLoading}
                              onScrollToBottom={handleAccountScroll}
                              onSearch={handleAccountSearch}
                              optionKeys={['id', 'name']}
                              errormsg={errormsg?.accountName}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label={'Sales Order Name'}
                              name={'salesOrder'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.salesOrder || '--'
                                  : formData?.salesOrder || 'Select Sales Order Name'
                              }
                              handleSelect={handleChange}
                              isRequired={false}
                              disabled={formData?.type === 'view'}
                              selectedOptions={formData?.salesOrder}
                              options={saleOrder}
                              optionKeys={['id', 'subject']}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label={'Quote Name'}
                              name={'quoteName'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.quoteName || '--'
                                  : formData?.quoteName || 'Select Quote Name'
                              }
                              isRequired={false}
                              disabled={formData?.type === 'view'}
                              selectedOptions={formData?.quoteName}
                              options={quote}
                              optionKeys={['id', 'subject']}
                              handleSelect={handleChange}
                              // isLoading={isOpportunityLoading}
                              // onScrollToBottom={handleOpportunityScroll}
                              // onSearch={handleOpportunitySearch}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label="Contact Name"
                              name={'contactName'}
                              handleSelect={handleChange}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.contactName || '--'
                                  : formData?.contactName || 'Select Contact Name'
                              }
                              selectedOptions={selectedOptions?.contactName}
                              options={contactListDropdown}
                              isLoading={isContactLoading}
                              onScrollToBottom={handleContactScroll}
                              onSearch={handleContactSearch}
                              optionKeys={['id', 'name']}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/quoteAi/images/companyInfo.svg" alt="" />
                      Address Information
                    </label>
                  </div>
                  <div className="quoteContent leadDetailInfo">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-6 col-md-6">
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-1 mb-2">
                              <h3>Billing Address</h3>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Billing Street'}
                                  name={'billingStreet'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Billing Street'
                                  }
                                  value={formData?.billingStreet}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Billing City'}
                                  name={'billingCity'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Billing City'
                                  }
                                  value={formData?.billingCity}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={' Billing State'}
                                  name={'billingState'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Billing State'
                                  }
                                  value={formData?.billingState}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={' Billing Country'}
                                  name={'billingCountry'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Billing Country'
                                  }
                                  value={formData?.billingCountry}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={' Billing Code'}
                                  name={'billingCode'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Billing Code'
                                  }
                                  value={formData?.billingCode}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6">
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-1 mb-1 d-flex align-items-center justify-content-between">
                              <h3>Shipping Address</h3>
                              {formData?.type !== 'view' && (
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="sameAsBilling"
                                    checked={formData?.sameAsBilling || false}
                                    onChange={handleSameAsBillingChange}
                                    disabled={
                                      !formData?.billingStreet &&
                                      !formData?.billingCity &&
                                      !formData?.billingState &&
                                      !formData?.billingCountry &&
                                      !formData?.billingCode
                                    }
                                  />
                                  <label className="form-check-label mt-1" htmlFor="sameAsBilling">
                                    Same as Billing Address
                                  </label>
                                </div>
                              )}
                            </div>

                            {/* Shipping Street */}
                            <div
                              className="col-12 col-sm-12 col-md-12 col-lg-12"
                            >
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping Street'}
                                  name={'shippingStreet'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Shipping Street'
                                  }
                                  value={formData?.shippingStreet}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingStreet}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            {/* City */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping City'}
                                  name={'shippingCity'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter City'}
                                  value={formData?.shippingCity}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingCity}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            {/* State */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping State'}
                                  name={'shippingState'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter State'}
                                  value={formData?.shippingState}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingState}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            {/* Country */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping Country'}
                                  name={'shippingCountry'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Country'}
                                  value={formData?.shippingCountry}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingCountry}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>

                            {/* Code */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-container">
                                <TextBox
                                  isRequired={false}
                                  label={'Shipping Code'}
                                  name={'shippingCode'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Code'}
                                  value={formData?.shippingCode}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.shippingCode}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              {/* Ordered Items */}
              <ChildInvoiceSalesOrder
                rowData={formData?.invoiceDetails}
                handleChangeForm={handleChangeForm}
                handleAddRow={handleAddRow}
                formData={formData}
                handleChange={handleChange}
                selectedOptions={selectedOptions}
                handleDeleteRow={handleDeleteRow}
                handleAddPriceSheetToItems={handleAddPriceSheetToItems}
                errormsg={errormsg}
              />
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img
                        className="me-2"
                        src="../assets/quoteAi/images/paymentInfo.svg" /* swap icon if needed */
                        alt=""
                      />
                      Payment Details
                    </label>
                  </div>

                  <div className="quoteContent leadDetailInfo">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <TextBox
                              isRequired={false}
                              label={'Payment Method'}
                              name={'paymentMethod'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.paymentMethod || '--'
                                  : formData?.paymentMethod || 'Enter Payment Method'
                              }
                              handleChange={handleChangeForm}
                              value={formData?.paymentMethod}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <div className="dateBox">
                              <label>Date of Payment</label>
                              {formData?.type === 'view' && !formData?.paymentDate ? (
                                <div>--</div>
                              ) : (
                                <div className="dtBox custom-date-wrapper">
                                  <DateBox
                                    name={'paymentDate'}
                                    className="custom-date-input"
                                    placeholder={
                                      formData?.type === 'view'
                                        ? '--'
                                        : 'Enter Due Date (MM/DD/YYYY)'
                                    }
                                    value={
                                      formData?.paymentDate
                                        ? formData?.paymentDate.substring(0, 10)
                                        : ''
                                    }
                                    disabled={formData?.type === 'view'}
                                    handleChange={handleChangeForm}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* ── Reference Number ──────────────────── */}
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="input-container">
                            <TextBox
                              isRequired={false}
                              label={'Reference Number'}
                              name={'referenceNumber'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.referenceNumber || '--'
                                  : formData?.referenceNumber || 'Enter Reference Number'
                              }
                              handleChange={handleChangeForm}
                              value={formData?.referenceNumber}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox mb-0">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img
                        className="me-2"
                        src="../assets/quoteAi/images/additionalInfo.svg"
                        alt=""
                      />
                      Additional Details
                    </label>
                  </div>
                  <div className="quoteContent leadDetailInfo notesLabel">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Terms and Conditions'}
                              name={'termsAndConditions'}
                              placeholder={
                                formData?.type === 'view' ? '--' : 'Enter Terms and Conditions'
                              }
                              value={formData?.termsAndConditions}
                              handleChange={handleChangeForm}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Description'}
                              name={'descriptionInformation'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                              value={formData?.descriptionInformation}
                              handleChange={handleChangeForm}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export default InvoiceForm;
